module.exports = __webpack_public_path__ + "static/img/preview-06.fdf08eaa.webp";